import React, { useMemo } from "react";
import { getDaysLeft } from "../../../utils/getDaysLeft.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
export const DaysLeft = () => {
  const { getTextByKey } = useContent();
  const { getMailMetaData, getMailStatus } = useMail();

  const daysLeft = useMemo(() => {
    return getMailMetaData().IsSaved ||
      (getMailStatus() !== "removed" && getMailMetaData().DownloadsCount > 50)
      ? null
      : getDaysLeft(getMailMetaData().Expiration);
  }, [getMailMetaData()]);

  const days =
    daysLeft?.days < 2 ? getTextByKey("hours-left") : getTextByKey("days-left");

  return (
    <>
      {daysLeft !== null && daysLeft.hours > 0 ? (
        <div className={`mail-expiration ${daysLeft !== null ? "" : "hidden"}`}>
          <div className="days-left-progress" aria-hidden="false"></div>
          <div className="days-left-text">{`${
            daysLeft.days < 2 ? daysLeft.hours : daysLeft.days
          } ${days}`}</div>
        </div>
      ) : null}
    </>
  );
};
